import React from "react";
import classNames from "classnames";
import { ChildrenProps } from "../../types";
import styles from "./CardSection.module.scss";

interface Props extends ChildrenProps {
    className?: string;
}

export const CardSection: React.FC<Props> = ({ className, children }) => (
    <div className={classNames(styles.section, className)}>{children}</div>
);
